var map = {
	"./": [
		"qoVm"
	],
	"./en": [
		"LVcC"
	],
	"./en.js": [
		"LVcC"
	],
	"./index": [
		"qoVm"
	],
	"./index.js": [
		"qoVm"
	],
	"./zh-CN": [
		"JAV0"
	],
	"./zh-CN.js": [
		"JAV0"
	],
	"./zh-TW": [
		"HwW6",
		0
	],
	"./zh-TW.js": [
		"HwW6",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "PBd7";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/locales lazy ^\.\/.*$
// module id = PBd7
// module chunks = 2